/**
 * Name data categories for bot and nickname generation.
 */
export const NAME_DATA = {
    funny: [
        "Hugh Mungus", "Ben Dover", "Mike Oxlong", "Gabe Itch", "Dixie Normous",
        "Tess Tickle", "Anita Bath", "I'm with Stupid ➡", "Loading...", "Buffering...",
        "Connection Lost", "Error 404", "Ctrl+Alt+Defeat", "404 Brain Not Found",
        "Fast & Curious", "Quiz Khalifa", "Sherlock Homie", "Sudeenly Sudden",
        "Ho Lee Chit", "Sum Ting Wong", "Wi Tu Lo", "Chris P. Bacon"
    ],
    stealth: [
        "Student", "Kahoot_User", "Unknown", "Participant", "Guest_01",
        "Classmate", "Reviewer", "Observer", "Anonymous", "\u200B", "‎ ",
        "Player 1", "Teacher's Pet", "A Student", "Not A Bot"
    ],
    glitch: [
        "H̸a̸c̸k̸e̸r̸", "S̶y̶s̶t̶e̶m̶", "E̷r̷r̷o̷r̷", "B̸o̸t̸", "010101",
        "R̶e̶c̶o̶n̶n̶e̶c̶t̶", "̦C̦o̦r̦r̦u̦p̦ț", "̿' ̿'\u034f\u034f̵͇̿̿ ̿ ̿", "Z̷a̷l̷g̷o̷",
        "NULL", "undefined", "NaN", "SEGFAULT", "0xDEADBEEF"
    ]
};

/**
 * Functions to transform text into various aesthetic or glitchy styles.
 */
export const TEXT_STYLES = {
    original: (s) => s,
    wide: (s) => s.split('').map(c => c.match(/[a-zA-Z]/) ? String.fromCharCode(c.charCodeAt(0) + 0xFEE0) : c).join(''),
    boxed: (s) => s.split('').map(c => c.match(/[a-zA-Z]/) ? String.fromCodePoint(c.codePointAt(0) + 127215) : c).join(''),
    bubbles: (s) => s.split('').map(c => c.match(/[a-zA-Z]/) ? String.fromCodePoint(c.codePointAt(0) + (c === c.toUpperCase() ? 9333 : 9327)) : c).join(''),
    strike: (s) => s.split('').join('\u0336') + '\u0336',
    glitch: (s) => s.split('').map(c => c + ['\u0300', '\u0301', '\u0302', '\u0303'][Math.floor(Math.random() * 4)]).join(''),
};

export const GLYPH_OPTIONS = [
    { id: 'wide', label: 'Aesthetic', transform: TEXT_STYLES.wide },
    { id: 'boxed', label: 'Boxed', transform: TEXT_STYLES.boxed },
    { id: 'bubbles', label: 'Bubbles', transform: TEXT_STYLES.bubbles },
    { id: 'strike', label: 'Cursed', transform: TEXT_STYLES.strike },
    { id: 'glitch', label: 'Zalgo', transform: TEXT_STYLES.glitch },
    { id: 'original', label: 'Clean', transform: TEXT_STYLES.original },
];